import { Container } from "react-bootstrap";

function TerminosServicio() {
  return (
    <Container className="mt-5 mb-5">
      {/* Señal de carga completa para el pre-renderizador (para páginas estáticas) */}
      <div id="snap-ready" style={{ display: "none" }}></div>

      <h1 className="mb-4">Términos del Servicio</h1>

      <h4>1. Aceptación de los términos</h4>
      <p>
        Al acceder y utilizar este sitio web, usted acepta estar sujeto a los
        siguientes términos y condiciones. Si no está de acuerdo con alguna
        parte de estos términos, no podrá acceder al servicio.
      </p>

      <h4>2. Modificaciones</h4>
      <p>
        Nos reservamos el derecho de actualizar, cambiar o reemplazar cualquier
        parte de estos Términos del Servicio mediante la publicación de
        actualizaciones y/o cambios en nuestro sitio web. Es su responsabilidad
        revisar esta página periódicamente para ver los cambios.
      </p>

      <h4>3. Productos y Servicios</h4>
      <p>
        Ciertos productos o servicios pueden estar disponibles exclusivamente en
        línea a través del sitio web. Estos productos o servicios pueden tener
        cantidades limitadas y están sujetos a devolución o cambio solo de
        acuerdo con nuestra Política de Reembolso.
      </p>

      <h4>4. Exactitud de la información</h4>
      <p>
        No nos hacemos responsables si la información disponible en este sitio
        no es exacta, completa o actual. El material en este sitio se
        proporciona solo para información general.
      </p>

      <h4>5. Ley aplicable</h4>
      <p>
        Estos Términos del Servicio y cualquier acuerdo aparte mediante el cual
        le proporcionemos servicios se regirán e interpretarán de acuerdo con
        las leyes de la República del Ecuador.
      </p>
    </Container>
  );
}

export default TerminosServicio;
